$output-background:  "#111C27" !default ;
$output-border-color: "#22303F" !default;
$output-color:  "#B7CDDF" !default;

@mixin background {
  background: #{$output-background};
  border: 2px solid #{$output-border-color};
}

.output-row {
  .output-row-block {
    @include background;
    .label {
      color: #{$output-color};
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/settings/hardware-setup/outputs/outputs-theme.scss